"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAndModifyProperty = exports.rbiPrefixToPaycomet = exports.keysToReplace = void 0;
const intl_logger_1 = require("@rbilabs/intl-logger");
//toLowerCase() will be applied to the searched key
exports.keysToReplace = ['order', 'rbiorderid'];
exports.rbiPrefixToPaycomet = 'RB';
const prefixLength = 2;
/**
 *
 * @param {any} obj - Original object to which the prefix is removed or added in the requested properties
 * @param {string[]} properties - Properties to replace that should be searched for in the object
 * @param {boolean} withPrefix - If true, the prefix will be added, if false, the prefix will be removed.
 * @param {string} psp - Payment service identifier.
 * @param {Record<string, { oldValue: any, newValue: any }>} changeLog - Object to log changes
 * @param {string} path - Current path in the object (used for nested objects)
 * @returns {void} It does not return any value, it only modifies the original object.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function findAndModifyProperty(obj, properties, withPrefix, psp = 'UNK', changeLog = {}, path = '') {
    if (obj === null || typeof obj !== 'object') {
        return;
    }
    for (const key of Object.keys(obj)) {
        const currentPath = path ? `${path}.${key}` : key;
        if (properties.includes(key.toLocaleLowerCase())) {
            const value = obj[key];
            if (withPrefix) {
                if (typeof value === 'string') {
                    const newValue = `${exports.rbiPrefixToPaycomet}${value}`;
                    changeLog[currentPath] = { newValue, oldValue: value };
                    obj[key] = newValue;
                }
            }
            else if (typeof value === 'string' && value.startsWith(exports.rbiPrefixToPaycomet)) {
                const newValue = value.substring(prefixLength);
                changeLog[currentPath] = { newValue, oldValue: value };
                obj[key] = newValue;
            }
        }
        if (typeof obj[key] === 'object') {
            findAndModifyProperty(obj[key], properties, withPrefix, psp, changeLog, currentPath);
        }
    }
    if (Object.keys(changeLog).length > 0 && path === '') {
        intl_logger_1.rbiLogger.info({
            changes: changeLog,
            psp,
            temporaryLog: true,
            withPrefix,
        }, 'Object modified by findAndModifyProperty function');
    }
}
exports.findAndModifyProperty = findAndModifyProperty;
//# sourceMappingURL=order-prefix.js.map